import React from 'react';
import Container from '../../components/General/Container';
import { Card, CardContent, CardImage, ContentWrapper, HepContentWrapper, ImgWrapper, Text, Wrapper } from './hep.styled';
import { GeneralText } from '../../components/General/Text';
import { Box } from '@mui/material';
import { IMAGES } from '../../../app/constants/const';
import communication from './communication.svg';

const Hep = () => {


  return (
    <Container>
      <Wrapper>
        <GeneralText variant='h1'>Working with Higher Education</GeneralText>
        <ImgWrapper>
          <img src={IMAGES.dsa_student.dsaStudents} alt=' A cartoon illustration showing three people collaboratively assembling large puzzle pieces. One person in navy blue stands holding a yellow puzzle piece, another in a yellow jumper reaches with a grey piece, and a third person in navy crouches while holding another yellow piece. The scene is set against a pale yellow background with subtle office-related icons, surrounded by a navy blue border. The illustration represents teamwork and creative problem-solving.' />
        </ImgWrapper>

        <GeneralText variant='h2'>Partnership, not just provision</GeneralText>

        <ContentWrapper>
          <Card>
            <CardImage>
              <img src={IMAGES.dsa_student.assessment} alt='Student Centred Focus (people in discussion icon) describing how every decision centres on student outcomes, including assessments, support strategies, and technology recommendations' />
            </CardImage>
            <CardContent >
              <Text variant='title'>
                Student Centred Focus
              </Text>
              <Text variant='pSemiBold'>
                Every decision we make centres on student outcomes. We work with you to ensure assessments, support strategies, and technology recommendations reflect students' academic contexts and institutional resources.
              </Text>
            </CardContent>
          </Card>

          <Card>
            <CardImage>
              <img src={IMAGES.dsa_student.support} alt="Partnership Approach (document and collaboration icon) describing Study Tech as an extension of the HEI's support team, emphasising regular communication and shared goals" />
            </CardImage>
            <CardContent >
              <Text variant='title'>
                Partnership Approach
              </Text>
              <Text variant='pSemiBold'>
                We see ourselves as an extension of your support team, not an external service. Regular communication, shared goals, and collaborative problem-solving define how we work.              </Text>
            </CardContent>
          </Card>

          <Card>
            <CardImage>
              <img src={communication} alt='Transparency & Communication (book and information icon) describing proactive, timely information sharing on student progress and assessment insights.' />
            </CardImage>
            <CardContent >
              <Text variant='title'>
                Transparency & Communication
              </Text>
              <Text variant='pSemiBold'>
                Clear, timely information sharing between all parties. We proactively update you on student progress, share insights from assessments, and respond quickly to queries or concerns.              </Text>
            </CardContent>
          </Card>
        </ContentWrapper>

        <HepContentWrapper><GeneralText variant='h2'>Let's Work Together</GeneralText></HepContentWrapper>
        <Box>
          <GeneralText variant='p'>
            Every institution has different needs, existing support structures, and ways of working. Rather than a one-size-fits-all approach, we'd like to understand how we can best support your students and complement your disability services.          </GeneralText>
          <ContentWrapper>
            <GeneralText variant='p'>
              Some of the ways we might work together:
            </GeneralText>
          </ContentWrapper>

          <ContentWrapper>
            <GeneralText variant='pBold'>
              Pre-assessment information<br />
            </GeneralText>
            <GeneralText variant='p'>
              Sharing course details, reasonable adjustments already in place, and any existing support helps our assessors provide recommendations that fit your students' actual academic context.
            </GeneralText>
          </ContentWrapper>


          <ContentWrapper>
            <GeneralText variant='pBold'>
              Ongoing communication<br />
            </GeneralText>
            <GeneralText variant='p'>
              Regular contact between your team and ours means we can coordinate support, share updates on student progress, and address any concerns quickly.            </GeneralText>
          </ContentWrapper>


          <ContentWrapper>
            <GeneralText variant='pBold'>
              Flexible coordination<br />
            </GeneralText>
            <GeneralText variant='p'>
              We work around your academic calendar, term dates, and existing provision to make things as straightforward as possible for both students and staff.            </GeneralText>
          </ContentWrapper>


          <ContentWrapper>
            <GeneralText variant='pBold'>
              Information sharing<br />
            </GeneralText>
            <GeneralText variant='p'>
              We're happy to discuss assessment outcomes, student progress, and how recommendations might work alongside your in-house support. No question is too small.            </GeneralText>
          </ContentWrapper>


          <ContentWrapper>

            <GeneralText variant='p'>
              Whether you're looking to establish a new partnership or simply want to discuss how we work, get in touch at <a href='mailto:hep@study.tech' className='email-link'>hep@study.tech</a>
            </GeneralText>
          </ContentWrapper>


        </Box>
      </Wrapper>
    </Container>
  );
};

export default Hep;
